module.exports = __webpack_public_path__ + "static/media/га.83a8a058.mp3";